import { useCallback } from 'react';
import { useAtom } from 'jotai';

import { FacilityFacilityTypeEnum } from '@/types/crm-screener';

import {
  allFacilitiesIntentAtom,
  useScreenerFacilityView
} from './useScreenerFacilityView';

interface UseFacilitySelectorControllerResult {
  selectFacility: (facilityId: string) => void;
  selectAllFacilities: (facilityType: FacilityFacilityTypeEnum) => void;
}

export const useFacilitySelectorController =
  (): UseFacilitySelectorControllerResult => {
    const { setFacilityId } = useScreenerFacilityView();
    const [, setIntent] = useAtom(allFacilitiesIntentAtom);

    const selectFacility = useCallback(
      (facilityId: string) => {
        setIntent(null);
        setFacilityId(facilityId);
      },
      [setIntent, setFacilityId]
    );

    const selectAllFacilities = useCallback(
      (facilityType: FacilityFacilityTypeEnum) => {
        setIntent({ facilityType });
      },
      [setIntent]
    );

    return {
      selectFacility,
      selectAllFacilities
    };
  };
